/**
 * Parse a date-only string ("YYYY-MM-DD", optionally with a time component)
 * as a local calendar date instead of UTC midnight.
 *
 * `new Date("2026-10-15")` is parsed as UTC midnight; reading it back with
 * local-time getters (`.getDate()`, `.getMonth()`, `.getDay()`) rolls the
 * date back by one day in any timezone behind UTC. Splitting the date part
 * out and constructing via `new Date(y, m-1, d)` builds the Date in local
 * time instead, so local getters read back the intended calendar date.
 */
export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const datePart = String(dateStr).split("T")[0];
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) {
    const fallback = new Date(dateStr);
    return isNaN(fallback) ? null : fallback;
  }
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

/** A locale date label, or null when the value is missing or not a real date. */
export function formatLocalDate(dateStr, options) {
  const d = parseLocalDate(dateStr);
  return d ? d.toLocaleDateString("en-US", options) : null;
}
